export const DEVICE_ATTACH_INIT = 'DEVICE_ATTACH_INIT';
export const DEVICE_ATTACH_SUCCESS = 'DEVICE_ATTACH_SUCCESS';
export const DEVICE_ATTACH_ERROR = 'DEVICE_ATTACH_ERROR';

export const TRACKING_INIT = 'TRACKING_INIT';
export const TRACKING_SUCCESS = 'TRACKING_SUCCESS';
export const TRACKING_ERROR = 'TRACKING_ERROR';

export const CSS_VIDEO_MUST_FINISHED_ERROR_CODE = 'PLY_CSS_00004';
export const TICK_PATH = '/tick';
export const TIME_PATH = '/time';
